/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import SurveyQuestionOption from './survey-question-option';
import SurveyQuestionOptionDetail from './survey-question-option-detail';
import SurveyQuestionOptionUpdate from './survey-question-option-update';
import SurveyQuestionOptionDeleteDialog from './survey-question-option-delete-dialog';

const SurveyQuestionOptionRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<SurveyQuestionOption />} />
    <Route path="new" element={<SurveyQuestionOptionUpdate />} />
    <Route path=":id">
      <Route index element={<SurveyQuestionOptionDetail />} />
      <Route path="edit" element={<SurveyQuestionOptionUpdate />} />
      <Route path="delete" element={<SurveyQuestionOptionDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default SurveyQuestionOptionRoutes;
